module.exports = __webpack_public_path__ + "img/gift4-01-c02-k2.3cf5a9c3.png";